<template>
    <div class="col-md-9">
        <div class="tab-content">
            <!-- <dashboard v-show="hasProjects" :role="role"></dashboard> -->

            <projects v-show="hasProjects" :role="role"></projects>
            <project-form-nav-wrapper v-show="hasProjects" :role="role"></project-form-nav-wrapper>
            <projects-archive :role="role"></projects-archive>

            <crew v-show="hasProjects" :role="role" :user="user"></crew>
            <add-crew-member v-show="hasProjects" :role="role"></add-crew-member>

            <overview v-show="currentProject" :role="role" :project="currentProject"></overview>
            <customer v-show="currentProject" :role="role" :user="user" :project="currentProject"></customer>
            <work-orders v-show="currentProject" :role="role" :user="user" :project="currentProject"></work-orders>
            <work-order-calendar v-show="currentProject" :role="role" :project="currentProject"></work-order-calendar>
            <change-orders v-show="currentProject" :role="role" :user="user" :project="currentProject"></change-orders>
            <draft-change-orders v-show="currentProject" :role="role" :user="user" :project="currentProject"></draft-change-orders>
            <selections v-show="currentProject"  :role="role" :user="user" :project="currentProject"></selections>
            <draft-selections v-show="currentProject"  :role="role" :user="user" :project="currentProject"></draft-selections>
            <templates v-show="currentProject"  :role="role" :user="user" :project="currentProject"></templates>
        </div>
        <div v-show="!hasProjects && !projectsLoading">
            <project-form-nav-wrapper :role="role"></project-form-nav-wrapper>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['role', 'user', 'team_id'],

        created: function() {
            let vm = this;
            Bus.$on('set-current-project', function (project) {
                vm.currentProject = project;
                return true;
            });

            Bus.$on('refresh-current-project', function() {
                vm.refreshProject();
                return true;
            });

            Bus.$on('projects-loading-status', function(isLoading) {
                vm.projectsLoading = isLoading;
                return true;
            });

            Bus.$on('has-projects', function(hasProjects) {
                vm.hasProjects = hasProjects;
                return true;
            });

            Echo.private(`team.${this.team_id}`)
                .listen('.email-tracking-event', (event) => {
                    console.log("GOT EMAIL EVENT!");
                    console.log(event);
                    Bus.$emit('email-tracking-event', event.emailTracking);
                });
        },

        mounted: function() {

        },

        data: function() {
            return {
                currentProject: null,
                projectsLoading: true,
                hasProjects: false
            };
        },

        computed: {
        },

        methods: {
            updateCurrentProject: function(project) {
                this.currentProject = project;
            },

            refreshProject: function() {
                axios.get('/api/projects/' + this.currentProject.id)
                    .then(response => {
                        this.updateCurrentProject(response.data);
                    })
                    .catch(error => {
                        console.log(error);
                    });
            }
        }
    }
</script>
